
export class AppUtility {

    public static isEmptyString(value: string): boolean {
        return value === null || value === undefined || value.trim() === '';
    }

    // The server hides sensitive values itself when the property's "Sensitive data" feature is off, so this only
    // shows what it received. It used to mask the last four digits here regardless of that setting.
    public static showEncryptedID(value: any): string {
        return (value === null || value === undefined || String(value).trim() === '') ? 'N/A' : String(value);
    }

    public static formatValue(value: string): string {
        return (value === null || value === undefined || value.trim() === '') ? 'N/A' : value;
    }

    public static showDocumentName(value): string {
        if (value === 'nationalId') {
          return 'National Id';
        } else if (value === 'dl') {
          return 'Driving License';
        } else if (value === 'passport') {
          return 'Passport';
        } else {
          return value;
        }
      }

}
